import Image from "next/image";
import { useTranslation } from "next-i18next";
import AboutUsImage from "@/images/about-us-photo.png";
import Link from "next/link";

const HeroContactUs = () => {
    const { t } = useTranslation();

    return (
        <div className={`relative z-10 flex flex-col md:flex-row bg-[linear-gradient(180deg,#091F59_0%,#1A3884_100%)] bg-cover bg-right bg-no-repeat h-full pb-[40px] md:pb-[112px] pt-[112px] md:pt-[160px] mt-[-80px] lg:mt-[-120px] rounded-[24px] lg:rounded-[64px] mx-[8px] mb-[20px] overflow-hidden`}>
            <div className="flex flex-col md:flex-row w-full max-w-[90%] mx-auto gap-[20px] relative z-10">
                <div className="flex flex-col flex-1 z-10 pb-[10px] md:pb-0 items-start justify-center md:w-[50%]">
                    <div className="flex flex-col gap-[15px] xs:gap-[20px] sm:gap-[30px] w-full">
                        <div>
                            <h1 className="xl:text-[56px] sm:text-[40px] xs:text-[32px] text-[24px] font-[700] leading-[120%] text-white max-w-[600px]">
                                {t("contact-us-page.hero-title")}
                            </h1>

                            <h2 className="xl:text-[56px] sm:text-[40px] xs:text-[32px] text-[24px] font-[700] leading-[120%] text-main-pink max-w-[600px]">
                                {t("contact-us-page.hero-subtitle")}
                            </h2>
                        </div>

                        <p className="text-[12px] xs:text-[14px] lg:text-[20px] text-gray-300 w-full">
                            {t("contact-us-page.hero-description")}
                        </p>

                        <Link href="/branches">
                            <button className="flex h-[48px] md:h-[56px] w-full sm:w-[300px] items-center justify-center gap-[10px] rounded-full bg-main-pink border border-main-pink transition duration-300 text-white hover:text-main-pink hover:bg-white">
                                <p className="text-[14px] font-[400] sm:text-[16px]">{t("contact-us-page.hero-button")}</p>
                            </button>
                        </Link>
                    </div>
                </div>

                <div className="relative flex items-center justify-center w-full md:w-[50%]">
                    <Image
                        src={AboutUsImage}
                        alt="About Us"
                        width={540}
                        height={566}
                        loading="lazy"
                    />
                </div>
            </div>
        </div>
    );
};

export default HeroContactUs;
